module.exports = __webpack_public_path__ + "static/media/productos-pro.da558a5d.svg";